import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
  const routes = [
    {
      path:'/',
      redirect:'/login'
    },
  {
    path: '/index',
    name: 'index',
    component: () => import( '../views/index'),
    children:[
      
      {
        path:'/shop',
        name:'店铺管理',
        component: () => import( '../views/shop'),
      },
      {
        path:'/commodity',
        name:'商品管理',
        component: () => import( '../views/commodity'),
      },
      {
        path:'/sort',
        name:'分类管理',
        component: () => import( '../views/sort'),
      },
      {
        path:'/unit',
        name:'单位管理',
        component: () => import( '../views/unit'),
      },
      {
        path:'/order',
        name:'订单管理',
        component: () => import( '../views/order'),
      },
      // {
      //   path:'/system',
      //   name:'系统设置',
      //   component: () => import( '../views/system'),
      // },
      
      {
        path:'/cashier',
        name:'收银员管理',
        component: () => import( '../views/cashier'),
      },
      {
        path:'/inventory',
        name:'盘点记录',
        component: () => import( '../views/inventory'),
      },
      {
        path:'/autoOrder',
        name:'自助售票机订单管理',
        component: () => import( '../views/autoOrder'),
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import( '../views/login')
  }
]

const router = new VueRouter({
  routes
})
export default router
